import React from 'react';
import { CLASSNAME_PREFIX, TRANSLATION_CONTEXT } from '../componentConfig';
import './VerificationDepositLeft.scss';

var VerificationDepositLeft = function VerificationDepositLeft(_ref) {
  var _ref$deposit = _ref.deposit,
      deposit = _ref$deposit === undefined ? {} : _ref$deposit,
      t = _ref.t;
  var amount = deposit.amount,
      currency = deposit.currency;

  return amount && currency ? React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__depositLeft' },
    React.createElement(
      'span',
      null,
      t(TRANSLATION_CONTEXT)('accountVerification.depositLeft'),
      ':'
    ),
    React.createElement(
      'span',
      { className: CLASSNAME_PREFIX + '-account-verification__deposit-value' },
      amount,
      ' ',
      currency
    )
  ) : null;
};

export default VerificationDepositLeft;